export var ExportOption;
(function (ExportOption) {
    ExportOption["download"] = "download";
    ExportOption["export"] = "export";
    ExportOption["print"] = "print";
    ExportOption["pdf"] = "pdf";
})(ExportOption || (ExportOption = {}));
